export function loadGTM(id) {
  function initGTM(window, document, tag, layer, gtmId) {
    const gtmScript = document.getElementById('gtm-script');
    if (!gtmScript) {
      const element = document.getElementsByTagName(tag)[0];
      const script = document.createElement(tag);
      script.id = 'gtm-script';
      script.async = true;
      const dl = layer !== 'dataLayer' ? `&l=${ layer}` : '';
      script.src = `https://www.googletagmanager.com/gtm.js?id=${ gtmId }${dl}`;
      element.parentNode.insertBefore(script, element);
    }
    const dataLayer = window[layer] || [];
    dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  }

  initGTM(window, document, 'script', 'dataLayer', id);
}

export function unloadGTM() {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const gtmScript = document.getElementById('gtm-script');
  if (gtmScript) {
    gtmScript.parentNode.removeChild(gtmScript);
  }
  const index = window.dataLayer?.findIndex((item) => item.event === 'gtm.js');
  if (index > -1) {
    window.dataLayer.splice(index, 1);
  }
}

export function checkifGTMLoaded() {
  return window.dataLayer?.some((item) => item.event === 'gtm.js');
}
